<template>
  <div class="labels-table">
    <div class="labels-table-container bg-white ob-scroll">
      <div class="label">{{ labelsHeader }}</div>

      <div class="font-weight-bold boards-labels-row">
        <div class="mt-2 mb-1">Category</div>
        <div class="mt-2 mb-1">Name</div>
        <div class="mt-2 mb-1">Icon</div>
        <div class="mt-2 mb-1">Color</div>
        <div class="mt-2 mb-1"></div>
        <div class="mt-2 mb-1"></div>
        <div class="mt-2 mb-1"></div>
      </div>

      <div v-for="label in labels" :key="label.id">
        <div class="boards-labels-row">
          <input
            :disabled="isArchivedLabels"
            class="form-control form-control-sm"
            placeholder="Enter a category for this label"
            v-model="label.category"
            type="text"
            @input="markAsDirty()"
          />
          <input
            :disabled="isArchivedLabels"
            class="form-control form-control-sm"
            placeholder="Enter a name for the label"
            v-model="label.title"
            type="text"
            @input="markAsDirty()"
          />

          <div>
            <v-select
              :disabled="isArchivedLabels"
              :options="labelsIcons"
              :reduce="(icon) => icon.key"
              :clearable="true"
              placeholder="Select a label icon"
              v-model="label.icon"
              :append-to-body="true"
              @input="markAsDirty()"
            >
              <template #selected-option="{ key, label }">
                <div class="d-flex align-items-center">
                  <div>
                    <i :class="key"></i>
                  </div>
                  <div class="ml-2">{{ label }}</div>
                </div>
              </template>

              <template #option="{ key, label }">
                <div class="d-flex align-items-center">
                  <div>
                    <i :class="key"></i>
                  </div>
                  <div class="ml-2">{{ label }}</div>
                </div>
              </template>
            </v-select>
          </div>
          <v-swatches
            :disabled="isArchivedLabels"
            :row-length="swatches.length"
            popover-x="left"
            v-model="label.color"
            :swatches="swatches"
            @input="markAsDirty()"
          />

          <div
            v-if="!isArchivedLabels"
            :class="{ disabled: label.isUsed }"
            class="delete-btn btn badgebutton danger active"
            v-b-tooltip:hover
            :title="label.isUsed ? 'This label can not be deleted because it was already used.' : ''"
            v-on:click.stop="deleteLabel(label)"
          >
            <i class="far fa-trash"></i>
          </div>

          <div
            v-if="!label.isDeleted && label.isUsed"
            class="btn badgebutton orange active"
            v-b-tooltip:hover
            title="Archive"
            v-on:click.stop="archiveLabelFunc(label)"
          >
            <i class="far fa-archive"></i>
          </div>

          <div
            v-if="label.isDeleted && label.isArchived"
            class="btn badgebutton primary active"
            v-b-tooltip:hover
            title="Reactivate"
            v-on:click.stop="reactivateLabel(label)"
          >
            <i class="fa fa-folder-open"></i>
          </div>
        </div>
      </div>

      <div v-if="!labels || !labels.length" class="p-2 text-center font-weight-bold" style="color: #aaa; font-size: 2.5rem">
        <i class="far fa-shapes"></i>
        <br />
        No Labels available
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { LabelDto } from '@/apiclient/apiclient_generated';
  import PublicConstants from '@/types/publicConstants';
  import VSwatches from 'vue-swatches';
  import OpsBoardIcons from '@/store/labelIcons';
  import { Prop } from 'vue-property-decorator';

  @Component({ components: { VSwatches } })
  export default class LabelsTable extends Vue {
    @Prop()
    public labels: LabelDto[];
    @Prop()
    public labelsHeader: string;
    @Prop() deleteLabelFunc: any;
    @Prop() archiveLabelFunc: any;
    @Prop() reactivateLabelFunc: any;
    @Prop() isArchivedLabels: boolean;

    isLoading = false;
    isDirty = false;

    swatches = PublicConstants.labelColors;

    get labelsIcons() {
      return OpsBoardIcons.icons;
    }

    async deleteLabel(label: LabelDto) {
      return this.deleteLabelFunc(label);
    }
    async archiveLabel(label: LabelDto) {
      return this.archiveLabelFunc(label);
    }
    async reactivateLabel(label) {
      return this.reactivateLabelFunc(label);
    }

    markAsDirty() {
      this.isDirty = true;
      this.$emit('labelUpdated');
    }
  }
</script>

<style scoped lang="scss">
  .labels-table {
    &-container {
      border-radius: 4px;
      background-color: white;
      overflow-y: auto;
      min-height: 250px;
      max-height: 400px;
      border: solid 1px #eaeaea;
      padding: 10px 20px 40px 10px;
    }

    .boards-labels-row {
      display: grid;
      justify-content: start;
      grid-template-columns: 1fr 1fr 1fr 30px 30px 30px;
      gap: 20px;
      align-items: center;
      padding-bottom: 10px;

      .btn {
        text-align: center;
      }
    }
  }

  .label {
    margin: 0;
  }

  .orange {
    background: orange;
  }
</style>

<style lang="scss">
  .vue-swatches {
    justify-content: left;
    display: flex;
    align-items: center;

    .vue-swatches__trigger {
      width: 27px !important;
      height: 27px !important;
      border-radius: 4px !important;
    }
  }
</style>
